import { c as _c } from "react/compiler-runtime";
import { isEqual } from 'es-toolkit';
import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';
import { useMountedEffect } from './useMountedEffect';
export type DisableSetter = () => void;

/**
 * @returns [value, setter, disableSetter]
 * @description 구독된 상태가 변경되면 업데이트 되는 상태값과 setter를 반환합니다.
 */
export function useSubscribedState(subscribedState, dependencyList) {
  const $ = _c(13);
  const valueState = useState(subscribedState);
  const [value, setValue] = valueState;
  let t0;
  if ($[0] !== subscribedState) {
    t0 = typeof subscribedState === "function" ? (subscribedState as () => T)() : subscribedState;
    $[0] = subscribedState;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subscribedValue = t0;
  let t1;
  if ($[2] !== dependencyList || $[3] !== subscribedValue || $[4] !== value) {
    t1 = () => {
      if (dependencyList) {
        return;
      }
      const subscribedValueType = typeof subscribedValue;
      bb9: switch (subscribedValueType) {
        case "object":
        case "function":
          {
            if (!isEqual(value, subscribedValue)) {
              setValue(subscribedValue);
            }
            break bb9;
          }
        default:
          {
            setValue(subscribedValue);
          }
      }
    };
    $[2] = dependencyList;
    $[3] = subscribedValue;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== dependencyList || $[7] !== subscribedValue) {
    t2 = dependencyList || [subscribedValue];
    $[6] = dependencyList;
    $[7] = subscribedValue;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useMountedEffect(t1, t2);
  let t3;
  if ($[9] !== dependencyList || $[10] !== subscribedValue || $[11] !== valueState) {
    t3 = dependencyList === false ? [subscribedValue, _temp] : valueState;
    $[9] = dependencyList;
    $[10] = subscribedValue;
    $[11] = valueState;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function _temp() {
  console.info("disabled setter");
}
export type SubscribedState<T> = ReturnType<typeof useSubscribedState<T>>;